<div
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 max-h-[90vh] overflow-hidden flex flex-col animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div *ngIf="isSaving() || isLoading()"
      class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Header -->
    <div class="flex items-center justify-between px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-2xl bg-amber-400/15 flex items-center justify-center text-amber-500">
          <span class="material-icons">{{ isEdit ? 'edit_note' : 'newspaper' }}</span>
        </div>
        <div>
          <h2 class="text-lg font-black text-slate-900 dark:text-white tracking-tight">
            {{ isEdit ? 'แก้ไขข่าวประชาสัมพันธ์' : 'สร้างข่าวประชาสัมพันธ์' }}
          </h2>
          <p class="text-[11px] text-slate-400 font-medium mt-0.5">
            public / internal · รูปปก 1 · รูปเนื้อหาสูงสุด 7
          </p>
        </div>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors cursor-pointer border-none bg-transparent">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto custom-scrollbar p-6 md:px-8 md:py-6 space-y-5">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            หัวข้อ <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">title</span>
            <input type="text" [(ngModel)]="form.title" placeholder="หัวข้อข่าว"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div class="relative">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            ประเภท <span class="text-rose-500">*</span>
          </label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">category</span>
            <input type="text" [(ngModel)]="searchCategoryText"
              (focus)="onInputFocus('category')" (blur)="closeDropdowns()"
              placeholder="ค้นหาประเภท..."
              class="w-full h-[46px] pl-10 pr-10 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-2 focus:ring-amber-200 outline-none" />
            <span class="material-icons text-slate-400 text-sm absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              [class.rotate-180]="openDropdown==='category'">expand_more</span>
          </div>
          <div *ngIf="openDropdown === 'category'" (mousedown)="$event.preventDefault()"
            class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-56 overflow-y-auto custom-scrollbar">
            <div *ngIf="filteredCategories.length === 0"
              class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบประเภท</div>
            <button *ngFor="let c of filteredCategories" type="button" (click)="selectCategory(c)"
              class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-slate-700 dark:text-slate-300 border-none bg-transparent">
              {{ c.name }} <span class="text-[11px] font-medium text-slate-400">({{ c.code }})</span>
            </button>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Status</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">flag</span>
            <select [(ngModel)]="form.status"
              class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
              <option value="draft">ร่าง (draft)</option>
              <option value="published">เผยแพร่ (published)</option>
              <option value="archived">เก็บถาวร (archived)</option>
            </select>
            <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Visibility</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">visibility</span>
            <select [(ngModel)]="form.visibility"
              class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
              <option value="public">public — ลูกค้า LIFF</option>
              <option value="internal">internal — พนักงาน</option>
            </select>
            <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
          </div>
        </div>

        <div class="md:col-span-2 relative">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            Site (ว่าง = Global / ทุก site)
          </label>
          <div class="flex flex-col sm:flex-row gap-2">
            <div class="relative flex-1">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">place</span>
              <input type="text" [(ngModel)]="searchSiteText"
                (focus)="onInputFocus('site')" (blur)="closeDropdowns()"
                placeholder="ค้นหาลาน..."
                class="w-full h-[46px] pl-10 pr-10 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-2 focus:ring-amber-200 outline-none" />
              <span class="material-icons text-slate-400 text-sm absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                [class.rotate-180]="openDropdown==='site'">expand_more</span>
              <div *ngIf="openDropdown === 'site'" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-56 overflow-y-auto custom-scrollbar">
                <button type="button" (click)="selectSite(null, 'ทุก site (Global)')"
                  class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-emerald-600 dark:text-emerald-400 border-none bg-transparent">
                  ทุก site (Global)
                </button>
                <div *ngIf="filteredSites.length === 0"
                  class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบลาน</div>
                <button *ngFor="let s of filteredSites" type="button" (click)="selectSite(s.id, s.name)"
                  class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-slate-700 dark:text-slate-300 border-none bg-transparent">
                  {{ s.name }} <span class="text-[11px] font-medium text-slate-400">#{{ s.id }}</span>
                </button>
              </div>
            </div>
            <button type="button" (click)="onUseCurrentSite()"
              class="px-3 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-[11px] font-bold text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer transition-colors whitespace-nowrap">
              ใช้ลานปัจจุบัน
            </button>
            <button type="button" (click)="onClearSite()"
              class="px-3 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-[11px] font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer transition-colors whitespace-nowrap">
              ทุก site
            </button>
          </div>

          <div *ngIf="isSiteNews" class="mt-3 space-y-2">
            <label
              class="flex items-start gap-3 px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer select-none hover:border-amber-200 transition-colors">
              <input type="checkbox" [(ngModel)]="form.showOnGlobal"
                class="mt-0.5 w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
              <span class="flex-1">
                <span class="flex items-center gap-1.5 text-sm font-bold text-slate-700 dark:text-slate-200">
                  <span class="material-icons text-amber-500 text-[18px]">home</span>
                  แสดงบนหน้า Home / ข่าวรวมของ LIFF ด้วย
                </span>
                <span class="block text-[11px] text-slate-400 mt-0.5">
                  ข่าวของลานจะแสดงที่หน้าลานใน LIFF เสมอ · ติ๊กเพื่อให้ลูกค้าทุกคนเห็นที่หน้า Home ด้วย (ป้าย "ประกาศจากลาน")
                </span>
              </span>
            </label>
            <div *ngIf="!form.showOnGlobal"
              class="flex items-start gap-2 px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200/70 dark:border-amber-700/40 text-[11px] font-medium text-amber-700 dark:text-amber-300">
              <span class="material-icons text-[16px]">info</span>
              <span>ข่าวนี้จะแสดงเฉพาะหน้าลานใน LIFF — ถ้าลานนี้ยังไม่ได้เผยแพร่หน้าลาน (จัดการเนื้อหาลาน) ลูกค้าจะมองไม่เห็นข่าวนี้</span>
            </div>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Publish From</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px] pointer-events-none z-[1]">event</span>
            <div class="absolute inset-0 flex items-center justify-between pl-10 pr-3 pointer-events-none z-[1]">
              <span class="text-sm font-bold text-slate-600 dark:text-slate-300">
                {{ formatDateTimeDisplay(form.publishFrom) }}
              </span>
              <span class="material-icons text-slate-400 text-lg">expand_more</span>
            </div>
            <input #publishFromPicker type="datetime-local" [(ngModel)]="form.publishFrom"
              (click)="publishFromPicker.showPicker()"
              class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Publish To</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px] pointer-events-none z-[1]">event_busy</span>
            <div class="absolute inset-0 flex items-center justify-between pl-10 pr-3 pointer-events-none z-[1]">
              <span class="text-sm font-bold text-slate-600 dark:text-slate-300">
                {{ formatDateTimeDisplay(form.publishTo) }}
              </span>
              <span class="material-icons text-slate-400 text-lg">expand_more</span>
            </div>
            <input #publishToPicker type="datetime-local" [(ngModel)]="form.publishTo"
              (click)="publishToPicker.showPicker()"
              class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
          </div>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สรุป</label>
          <textarea [(ngModel)]="form.summary" rows="2" placeholder="สรุปสั้นๆ ของข่าว"
            class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none placeholder:text-slate-400"></textarea>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รายละเอียด</label>
          <textarea [(ngModel)]="form.body" rows="6" placeholder="เนื้อหาข่าว"
            class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-y min-h-[140px] placeholder:text-slate-400"></textarea>
        </div>

        <!-- Cover image -->
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รูปปก</label>
          <div
            class="relative rounded-2xl border-2 border-dashed transition-all duration-200 cursor-pointer"
            [ngClass]="isCoverDragOver
              ? 'border-amber-400 bg-amber-50/70 dark:bg-amber-900/20'
              : 'border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 hover:border-amber-300 hover:bg-amber-50/40'"
            (dragenter)="onCoverDragEnter($event)"
            (dragover)="onCoverDragOver($event)"
            (dragleave)="onCoverDragLeave($event)"
            (drop)="onCoverDrop($event)"
            (click)="coverFileInput.click()">
            <input #coverFileInput type="file" accept="image/*" class="sr-only" (change)="onCoverSelected($event)" />
            <div class="flex flex-col sm:flex-row items-center gap-4 px-4 py-5 pointer-events-none">
              <div
                class="w-28 h-20 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 flex items-center justify-center shrink-0">
                <img *ngIf="coverPreview() as preview" [src]="preview" alt="cover" class="w-full h-full object-cover" />
                <span *ngIf="!coverPreview()" class="material-icons text-3xl text-slate-300">image</span>
              </div>
              <div class="text-center sm:text-left">
                <p class="text-sm font-bold text-slate-600 dark:text-slate-300">
                  {{ isCoverDragOver ? 'วางรูปที่นี่' : 'ลากรูปมาวาง หรือคลิกเพื่อเลือกไฟล์' }}
                </p>
                <p class="text-[11px] text-slate-400 mt-1">รองรับไฟล์รูปภาพ · จะอัปโหลดเป็น news/{{ '{' }}guid{{ '}' }}.jpg</p>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center gap-2 mt-3">
            <button *ngIf="coverBase64" type="button" (click)="clearCoverSelection()"
              class="px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-xs font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer transition-colors">
              ยกเลิกรูปใหม่
            </button>
            <p *ngIf="form.coverImageUrl && !coverBase64"
              class="text-[11px] text-slate-400 break-all font-mono">
              {{ form.coverImageUrl }}
            </p>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Link URL</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">link</span>
            <input type="text" [(ngModel)]="form.linkUrl" placeholder="https://... หรือหน้าในแอป LIFF เช่น /coupon"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Link Label</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">label</span>
            <input type="text" [(ngModel)]="form.linkLabel" placeholder="ข้อความลิงก์"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div class="md:col-span-2">
          <label
            class="inline-flex items-center gap-3 px-4 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer select-none hover:border-amber-200 transition-colors">
            <input type="checkbox" [(ngModel)]="form.pin"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
            <span class="material-icons text-amber-500 text-[18px]">push_pin</span>
            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">ปักหมุด</span>
          </label>
        </div>

        <!-- Gallery -->
        <div class="md:col-span-2 space-y-3">
          <div class="flex items-center justify-between gap-2">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider">
              รูปในเนื้อหา ({{ galleryCount }}/7)
            </label>
            <label *ngIf="canAddGallery"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-amber-400/15 text-amber-600 text-[11px] font-bold cursor-pointer hover:bg-amber-400/25 transition-colors">
              <span class="material-icons text-[16px]">add_photo_alternate</span>
              เพิ่มรูป
              <input type="file" accept="image/*" multiple class="hidden" (change)="onGallerySelected($event)" />
            </label>
          </div>

          <div *ngIf="galleryImages().length === 0 && pendingGallery.length === 0"
            class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 px-4 py-6 text-center text-xs text-slate-400 font-medium">
            ยังไม่มีรูปในเนื้อหา — แนบได้สูงสุด 7 รูป
          </div>

          <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
            <div *ngFor="let img of galleryImages()"
              class="relative rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 aspect-[4/3]">
              <img [src]="img.fullPath" [alt]="img.caption || ''" class="w-full h-full object-cover" />
              <button type="button" (click)="deactivateGalleryImage(img)" title="ลบรูป"
                class="absolute top-2 right-2 w-8 h-8 rounded-xl bg-rose-500/90 text-white flex items-center justify-center border-none cursor-pointer hover:bg-rose-600">
                <span class="material-icons text-[16px]">delete</span>
              </button>
            </div>
            <div *ngFor="let g of pendingGallery; let i = index"
              class="relative rounded-2xl overflow-hidden border border-amber-200 dark:border-amber-800 bg-amber-50/40 dark:bg-amber-900/20 aspect-[4/3]">
              <img [src]="g.preview" [alt]="g.fileName" class="w-full h-full object-cover" />
              <span class="absolute bottom-2 left-2 px-2 py-0.5 rounded-lg bg-black/50 text-[10px] font-bold text-white">ใหม่</span>
              <button type="button" (click)="removePendingGallery(i)" title="ยกเลิก"
                class="absolute top-2 right-2 w-8 h-8 rounded-xl bg-slate-800/80 text-white flex items-center justify-center border-none cursor-pointer">
                <span class="material-icons text-[16px]">close</span>
              </button>
            </div>
          </div>
          <p *ngIf="!isEdit && pendingGallery.length > 0" class="text-[11px] text-slate-400 font-medium">
            รูปใหม่จะอัปโหลดหลังบันทึกข่าว
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex flex-col-reverse sm:flex-row justify-between gap-3 px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 shrink-0 bg-slate-50/50 dark:bg-slate-900/40">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 bg-transparent">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
        <button type="button" (click)="onClose()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-500 hover:bg-white dark:hover:bg-slate-800 transition-colors cursor-pointer bg-transparent">
          ยกเลิก
        </button>
        <button type="button" [disabled]="isSaving() || isLoading()" (click)="onSave()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-slate-900 text-sm font-black shadow-lg shadow-amber-500/20 transition-all cursor-pointer border-none flex items-center gap-2">
          <span class="material-icons text-[18px]">save</span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && editId"
  [entityType]="activityEntityTypes.News"
  [entityId]="editId!"
  title="ประวัติข่าว"
  [subtitle]="'#' + editId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
